import { createContext } from 'react'
import type { BrandConfig } from './types'

/** React context that holds the active brand configuration. */
export const BrandContext = createContext<BrandConfig | null>(null)
